import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, useMemo, useState } from 'react';
import { CourseEnrolment } from 'src/ReduxStorage/InstitutionAdminSettings/types';
import { MultiSelect } from 'src/web/components/Input/Dropdowns/MultiSelect/component';
import { ModalDialog } from 'src/web/components/Modals/ModalDialog';
import {
  ErrorMessage,
  GroupList,
  GroupListItem,
  GroupNameHeading,
  StyledTimesButton,
  CourseDetailItem,
  CourseName,
  CoursePath,
  TotalSelectedMembers,
} from '../styles';

export interface RemoveFromCoursesModalProps {
  isRemovingFromCoursesLoading: boolean;
  totalSelectedMembers: number;
  errorMessage: string;
  courses: CourseEnrolment[];
  onRemoveFromCourses: (coursePaths: string[]) => void;
  onHide: () => void;
}

export const RemoveFromCoursesModal: FunctionComponent<RemoveFromCoursesModalProps> = ({
  isRemovingFromCoursesLoading,
  errorMessage,
  totalSelectedMembers,
  courses,
  onHide,
  onRemoveFromCourses,
}) => {
  const [selectedValues, setSelectedValues] = useState<
    Readonly<{ label: string; value: string }[]>
  >([]);
  const removeSelectedValues = (removedValue: string): void => {
    setSelectedValues((prev) =>
      prev.filter(({ value }) => value !== removedValue)
    );
  };
  const coursesLookupMap = useMemo(() => {
    const coursesMapByPath: { [path: string]: CourseEnrolment } = {};
    courses.forEach((course) => {
      coursesMapByPath[course.path] = course;
    });
    return coursesMapByPath;
  }, [courses]);

  const coursesOptions = useMemo(
    () =>
      courses.map((course) => ({
        label: course.name,
        value: course.path,
      })),
    [courses]
  );
  return (
    <>
      <ModalDialog
        show
        center
        small
        onHide={onHide}
        title="Remove from courses"
        actions={[
          {
            label: 'Remove from courses',
            showSpinner: isRemovingFromCoursesLoading,
            disabled: isRemovingFromCoursesLoading,
            onClick: () =>
              onRemoveFromCourses(
                selectedValues.map(({ value: coursePath }) => coursePath)
              ),
            type: 'primary-kelp',
          },
        ]}
      >
        <TotalSelectedMembers>
          {totalSelectedMembers} member{totalSelectedMembers > 1 ? 's' : ''}
        </TotalSelectedMembers>
        <MultiSelect
          label="Select courses to remove team members from"
          placeholder="Add a course"
          controlShouldRenderValue={false}
          options={coursesOptions}
          value={selectedValues}
          onChange={(values) => setSelectedValues(values)}
        />
        {selectedValues.length > 0 && (
          <GroupList>
            <GroupNameHeading>Course name / URL</GroupNameHeading>
            {selectedValues.map(({ label, value }) => (
              <GroupListItem>
                <CourseDetailItem>
                  <img
                    src={coursesLookupMap[value].promoImage}
                    alt="course-promoImage"
                  />
                  <div>
                    <CourseName>{label}</CourseName>
                    <CoursePath>{value}</CoursePath>
                  </div>
                </CourseDetailItem>
                <StyledTimesButton
                  type="button"
                  onClick={() => removeSelectedValues(value)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </StyledTimesButton>
              </GroupListItem>
            ))}
          </GroupList>
        )}
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </ModalDialog>
    </>
  );
};
